import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Layout from '../layout/Layout'
import DatePicker from 'react-datepicker'
import Spinner from '../layout/Spinner'
import { api } from '../utils/Api'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const HistoryReport = () => {
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [loading, setLoading] = useState(true)
    const [columns, setColumns] = useState([])
    const [rows, setRows] = useState([])

    useEffect(() => {
        search()
    }, [])

    const search = () => {
        getHistoryList()
    }

    const columna = [
        { key: 'driver', name: 'Number'},
        { key: 'type', name: 'Type'},
        { key: 'date', name: 'Date'},
        { key: 'user', name: 'User'},
        { key: 'customer', name: 'Customer'},
        { key: 'yards', name: 'Yards'},
    ]

    const getHistoryList = async() => {
        setLoading(true)
        const start = `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`
        const end = `${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`

        const url = api + `/history/search?startDate=${start}&endDate=${end}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.get(url)
            historyData(data)
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    const historyData = (histories) => {
        let list = []
        histories.map((history) => {
            list.push({
                type: history.type,
                customer: history.customer.name,
                date: history.date ? history.date.substring(0,10) : 'No Date',
                user: history.user.name,
                yards: history.yards,
                number: history.number,
            })
        })
        setRows(list)
        setColumns(columna)
        setLoading(false)
    }


    const RenderLoading = () => {
        return <Spinner />
    }

    const RenderTable = () => {
        return <div style={{maxWidth: '100%', marginTop: 20, marginBottom: 20}}>
            <table className="table">
                <thead>
                    <tr>
                        {
                            columna.map((column) => {
                                return <th>{column.name}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.length === 0 ?
                        <tr>
                            <td colSpan={7}>
                                <p className='text-center'>No histories available</p>
                            </td>
                        </tr>
                        :
                        rows.map((inspection, index) => {
                            return (
                                <tr key={index}>
                                    <td>{inspection.number}</td>
                                    <td>{inspection.type}</td>
                                    <td>{inspection.date}</td>
                                    <td>{inspection.user}</td>
                                    <td>{inspection.customer}</td>
                                    <td>{inspection.yards}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    }    

    const SearchCustomer = () => (
        <div className="form-group row">
            <div className='col-sm-2'>
                <label className='text-muted'>Start Date</label>
                <DatePicker
                    selected={startDate}
                    minDate={new Date('01/01/2022')}
                    maxDate={new Date()}
                    onChange={(date) => setStartDate(date)}
                />
            </div>
            <div className='col-sm-2'>
                <label className='text-muted'>End Date</label>
                <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    minDate={startDate}
                    maxDate={new Date()}
                />
            </div>
            <div className="col-sm-2">
                <label className='text-muted'>&nbsp;</label>
                <button onClick={search} className='btn btn-primary w-100'>
                    <FontAwesomeIcon icon={faSearch} />&nbsp;Search
                </button>
            </div>
        </div>
    )

    return (
        <Layout
            title='History Loads and Jobs'
            description='Report'
            className='container col-md-10'
        >
            <SearchCustomer/>
            {
                loading ? <RenderLoading/> : <RenderTable/>
            } 

        </Layout>
    )
}

export default HistoryReport